<template>
        <div 
            class="projectstructure-filter-line"
            >
            <!-- filter type dropdown -->
            <DropDownOutlinedFlat
                class="mr-1"
                :style="!is_line_complete_and_active?'opacity: 0.5':''"
                :options="filter_types[tree_type]"
                :value="object.type"
                label="filtertype"
                :width="80"
                :height="45"
                :background_color="background_color"
                @change="changeObjectType($event)"
            />
            <template v-for="(input_field, input_index) in input_fields_by_type[object.type]">
                <DropDownOutlinedFlat
                    class="mr-1"
                    :style="!is_line_complete_and_active?'opacity: 0.5':''"
                    v-if="input_field.ui === 'dropdown'"
                    :key="`input${input_index}`"
                    :options="getDropDownOptions(input_field.key)"
                    :value="object[input_field.key]"
                    :label="input_field.label"
                    :width="input_field.key === 'operator' && !['filter_parent', 'filter_linked'].includes(object.type)?55:80"
                    :height="45"
                    :background_color="background_color"
                    @change="changeInput(input_field.key, $event)"
                />
                <DisableableInputField
                    class="mr-1"
                    :style="!is_line_complete_and_active?'opacity: 0.5':''"
                    v-else-if="input_field.ui === 'input'"
                    :key="`input${input_index}`"
                    :label="input_field.label"
                    style="height: 45px"
                    width="100px"
                    :value="object[input_field.key]"
                    :input_type="getInputType(input_field.key)"
                    :background_color="background_color"
                    :option_list="getOptionsList(input_field.key)"
                    @change="changeInput(input_field.key, $event)"
                    />
                <DropDownOutlinedFlat
                    v-if="input_field.key === 'direct' && show_target_options"
                    class="mr-1"
                    :style="!is_line_complete_and_active?'opacity: 0.5':''"
                    :key="`input_target${input_index}`"
                    :options="dropdown_options_by_key.target_options"
                    :value="object.target"
                    label="target"
                    :width="55"
                    :height="45"
                    :background_color="background_color"
                    @change="changeInput('target', $event)"
                />
            </template>
            <TTooltip value="Remove filter line" left>
                <TIcon 
                    class="cursor-pointer"
                    name="close-circle"
                    :style="!is_line_complete_and_active?'opacity: 0.5':''"
                    @click.native="$emit('deleteFilterLine', is_line_complete_and_active)"
                />
            </TTooltip>
            <TTooltip v-if="is_line_complete" :value="is_line_complete_and_active ? 'Deactivate filter line' : 'Activate filter line'" left>
                <TIcon 
                    class="cursor-pointer"
                    name="power"
                    :style="!is_line_complete_and_active?'opacity: 0.5':''"
                    @click.native="object.active = !object.active, is_line_complete_and_active?$emit('changeLineComplete'):''"
                />
            </TTooltip>
        </div>
  </template>
  <script>
    import Vue from 'vue';

    import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue';
    import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue';
    import TIcon from '@/components/Taktify/TIcon.component.vue';
    import TTooltip from '@/components/Taktify/TTooltip.component.vue';

    export default {
      props: ['tree_type', 'object', 'background_color', 'object_defaults_by_type'],
      components: {
        DropDownOutlinedFlat,
        DisableableInputField,
        TIcon,
        TTooltip,
      },
      data: () => ({
        filter_types: {
            spatial: [
                {text: 'attribute', value: 'filter_attr'},
                {text: 'property', value: 'filter_prop'},
                {text: 'parent', value: 'filter_parent'},
                {text: 'link', value: 'filter_linked'},
                ],
            process: [
                {text: 'attribute', value: 'filter_attr'},
                {text: 'parent', value: 'filter_parent'},
                {text: 'link', value: 'filter_linked'},
            ]
        },
        input_fields_by_type: {
            filter_attr: [
                {label: 'attributename', key: 'attributename', ui: 'dropdown'},
                {label: 'operator', key: 'operator', ui: 'dropdown'},
                // {label: 'datatype', key: 'value_data_type', ui: 'dropdown'},
                {label: 'value', key: 'value', ui: 'input'},
            ],
            filter_prop: [
                {label: 'propset', key: 'propsetname', ui: 'input'},
                {label: 'prop', key: 'propname', ui: 'input'},
                {label: 'operator', key: 'operator', ui: 'dropdown'},
                // {label: 'datatype', key: 'value_data_type', ui: 'dropdown'},
                {label: 'value', key: 'value', ui: 'input'},
            ],
            filter_parent: [
                {label: 'parent type', key: 'parent_type', ui: 'dropdown'},
                {label: 'parent id', key: 'parent_id', ui: 'dropdown'},
                {label: 'operator', key: 'operator', ui: 'dropdown'},
                {label: 'direct', key: 'direct', ui: 'dropdown'},
            ],
            filter_linked: [
                {label: 'link type', key: 'link_type', ui: 'dropdown'},
                {label: 'link id', key: 'link_id', ui: 'dropdown'},
                {label: 'operator', key: 'operator', ui: 'dropdown'},
                // {label: 'direct', key: 'direct', ui: 'dropdown'},
            ],
        },
        dropdown_options_by_key: {
            attributename: {
                spatial: [
                    {text: 'IFC Type', value: 'ifc_type', input_type: 'text'},
                    {text: 'Name', value: 'name', input_type: 'text'},
                    {text: 'Description', value: 'description', input_type: 'text'},
                    {text: 'TAKT.ing ID', value: 'id', input_type: 'number'},
                    {text: 'Express ID', value: 'express_id', input_type: 'number'},
                    {text: 'Global ID', value: 'global_id', input_type: 'text'},
                    {text: 'Height', value: 'height', input_type: 'number'},
                    {text: 'Width', value: 'width', input_type: 'number'},
                    {text: 'Length', value: 'length', input_type: 'number'},
                    {text: 'Volume', value: 'volume', input_type: 'number'},
                    {text: 'Floor Area', value: 'floor_area', input_type: 'number'},
                    {text: 'Side Area', value: 'side_area', input_type: 'number'},
                    {text: 'Perimeter', value: 'perimeter', input_type: 'number'},
                    {text: 'Surface', value: 'surface', input_type: 'number'},
                    {text: 'Side Area', value: 'side_area', input_type: 'number'},
                    {text: 'Lateral Surface', value: 'lateral_surface', input_type: 'number'},
                    {text: 'Weight', value: 'Weight', input_type: 'number'},
                ],
                process: [
                    {text: 'Text', value: 'text', input_type: 'text'},
                    {text: 'ID', value: 'id', input_type: 'number'},
                    {text: 'Done', value: 'done', input_type: 'text'},
                ],
            },
            operator_text: [
                {text: '=', value: '==='},
                {text: '!=', value: '!=='},
                {text: 'includes', value: 'includes'},
                {text: 'excludes', value: 'excludes'},
                {text: 'startswith', value: 'startswidth'},
                {text: 'endswith', value: 'endswidth'},
            ],
            operator_number: [
                {text: '=', value: '==='},
                {text: '!=', value: '!=='},
                {text: '<', value: '<'},
                {text: '<=', value: '<='},
                {text: '>', value: '>='},
                {text: '>=', value: '>='},
            ],
            operator_all: [
                {text: '=', value: '==='},
                {text: '!=', value: '!=='},
                {text: '<', value: '<'},
                {text: '<=', value: '<='},
                {text: '>', value: '>='},
                {text: '>=', value: '>='},
                {text: 'includes', value: 'includes'},
                {text: 'excludes', value: 'excludes'},
                {text: 'startswith', value: 'startswidth'},
                {text: 'endswith', value: 'endswidth'},
            ],
            operator_parent: [
                {text: 'is parent', value: 'includes'},
                {text: 'is not parent', value: 'excludes'},
            ],
            operator_link: [
                {text: 'is linked', value: 'includes'},
                {text: 'is not linked', value: 'excludes'},
            ],
            value_data_type: [
                {text: 'number', value: 'number'},
                {text: 'text', value: 'text'},
                {text: 'bool', value: 'boolean'},
            ],
            direct: [
                {text: 'true', value: true},
                {text: 'false', value: false},
            ],
            parent_type_spatial: [
                {text: 'Project', value: 'projects'},    
                {text: 'Site', value: 'sites'},    
                {text: 'Building', value: 'buildings'},    
                {text: 'Storey', value: 'buildingstoreys'},    
                {text: 'Space', value: 'spacegroups'},    
                {text: 'Elementassembly', value: 'elementassemblies'},    
                {text: 'Zone', value: 'spatialzones'},    
            ],
            parent_type_process: [
                {text: 'Project', value: 'projects'},    
                {text: 'Train', value: 'trains'},    
                {text: 'Taktarea', value: 'taktareas'},    
                {text: 'Waggon', value: 'twaggons'},    
                {text: 'Workpackage', value: 'tworkpackages'},      
            ],
            link_type_spatial: [
                {text: 'Project', value: 'projects'},    
                {text: 'Train', value: 'trains'},    
                {text: 'Taktarea', value: 'taktareas'},    
                {text: 'Waggon', value: 'twaggons'},    
                {text: 'Workpackage', value: 'tworkpackages'},      
                {text: 'Workstep', value: 'tworksteps'},      
            ],
            link_type_spatial_direct: [  
                {text: 'Taktarea', value: 'taktareas'},    
                {text: 'Workstep', value: 'tworksteps'},      
            ],
            link_type_process: [
                {text: 'Project', value: 'projects'},    
                {text: 'Site', value: 'sites'},    
                {text: 'Building', value: 'buildings'},    
                {text: 'Storey', value: 'buildingstoreys'},    
                {text: 'Space', value: 'spacegroups'},    
                {text: 'Elementassembly', value: 'elementassemblies'},    
                {text: 'Zone', value: 'spatialzones'},    
                {text: 'Element', value: 'elements'},    
            ],
            link_type_process_direct: [  
                {text: 'Element', value: 'elements'},    
            ],
            target_options: [
                {text: 'All', value: 'all'},    
                {text: 'Taktarea', value: 'taktareas'},    
                {text: 'Workstep', value: 'tworksteps'},     
            ],
        },
      }),
      computed: {
        is_line_complete_and_active() {
            if(this.is_line_complete && this.object.active) {
                return true;
            } else {
                return false;
            }
        },
        is_line_complete() {
            if (this.object.type === 'filter_attr') {
                if (this.object.value) {
                    return true;
                } else {
                    return false;
                }
            } else if (this.object.type === 'filter_prop') {
                if(this.object.propsetname && this.object.propname && this.object.value) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true
            }

        },
        value_input_type() {
            if (this.object.type === 'filter_attr'){
                return this.dropdown_options_by_key.attributename[this.tree_type].find(name => name.value === this.object.attributename).input_type;
            } else {
                return 'text';
            }
        },
        operator_dropdown_options() {
            if (this.object.type === 'filter_parent') {
                    return this.dropdown_options_by_key.operator_parent;
                } else if (this.object.type === 'filter_linked') {
                    return this.dropdown_options_by_key.operator_link;
                } else if (this.object.type === 'filter_prop') {
                    let value = this.object.value;
                    if (value === '') {
                        return this.dropdown_options_by_key.operator_all;
                    } else if(!isNaN(value)) { //is number
                        return this.dropdown_options_by_key.operator_number;
                    } else { //is string
                        return this.dropdown_options_by_key.operator_text;
                    }
                } else { // filter_attr
                    let input_type = this.getInputType('value');
                    return this.dropdown_options_by_key[`operator_${input_type}`];
                }
        },
        link_type_dropdown_options() {
            if (this.object.type === 'filter_linked' && this.object.direct && this.object.direct !== 'false') {
                return this.dropdown_options_by_key[`link_type_${this.tree_type}_direct`]
            } else {
                return this.dropdown_options_by_key[`link_type_${this.tree_type}`]
            }
        },
        id_dropdown_options() {
            let options = [{text: 'any', value: -1}];
            if (this.object.type === 'filter_parent' || this.object.type === 'filter_linked') {
                let type;
                if (this.object.type === 'filter_parent') {
                    type = this.object.parent_type;
                } else {
                    type = this.object.link_type;
                }
                if (type === 'projects') {
                    let project = this.$store.state.Ultra.projects[this.$route.params.project_id];
                    options[0] = {text: `${project.id}: ${project.name}`, value: project.id}
                } else {
                    let objects = Object.values(this.$store.state.Ultra[type]);
                    for (let i = 0; i < objects.length; i++) {
                        let obj = objects[i];
                        let id = obj.id;
                        let name;
                        if (type === 'twaggons') {
                            if (obj.token && obj.token !== '') {
                                name = obj.token
                            } else {
                                name = `waggon ${id}`
                            }
                        } else if (type.includes('steps')) {
                            name = obj.text;
                        } else if (obj.name) {
                            name = obj.name;
                        } else {
                            name = `${type} ${id}`
                        }
                        options[options.length] = {text: `${id}: ${name}`, value: id};
                    }
                }
                
            }
            return options;
        },
        show_target_options() {
            if (this.tree_type === 'spatial' && this.object.type === 'filter_linked' && (this.object.direct === false || this.object.direct === 'false') && ['projects', 'trains', 'taktareas'].includes(this.object.link_type)) {
                return true;
            } else {
                return false;
            }
        }
      },
      watch: {
        is_line_complete_and_active(val) {
            if (!val) {
                this.$emit('changeLineComplete')
            }
        },
        value_input_type() {
            this.object.value = "";
        },
        operator_dropdown_options(val) {
            const index = val.findIndex(operator => operator.value === this.object.operator);
            if (index === -1) {
                this.object.operator = val[0].value;
            } else {
                this.object.operator = val[index].value;
            }
        },
        link_type_dropdown_options(val) {
            // only trigger when in filter_linked
            if (this.object.type === 'filter_linked' && val.findIndex(link_type => link_type.value === this.object.link_type) === -1) {
                this.object.link_type = val[0].value;
            }
        },
        'object.parent_type'() {
            if (this.object.type === 'filter_parent' && this.object.parent_id !== -1) {
                this.object.parent_id = -1;
            }
        },
        'object.link_type'(val, oldVal) {
            // if filter_linked 
            if (this.object.type === 'filter_linked') {
                if (!this.object.direct || this.object.direct === 'false') { // not direct
                    if (['twaggons', 'tworkpackages', 'tworksteps'].includes(val) && this.object.target !== 'tworksteps') {
                            this.object.target = 'tworksteps';
                        } 
                        // change from twaggons/tworkpackages/tworksteps to other
                        else if (oldVal && ['twaggons', 'tworkpackages', 'tworksteps'].includes(oldVal) && !['twaggons', 'tworkpackages', 'tworksteps'].includes(val)) {
                            this.object.target = 'all';
                        }
                } else { // direct
                    this.object.target = val;
                }
            }
        },
        'object.direct'(val) {
            if (this.object.type === 'filter_linked') {
                if (val && val !== 'false') { //  direct changed to true
                        if (this.object.target !== this.object.link_type) {
                            this.object.target = this.object.link_type;
                        }
                    } 
                    else if (val === false || val === 'false') {//  direct changed to false
                        if (['projects', 'trains', 'taktareas'].includes(this.object.link_type)) {
                            this.object.target = 'all';
                        }
                    }
            }
        },
      },
      methods: {
          changeObjectType(type) {
            let default_object = this.object_defaults_by_type[this.tree_type][type];
            let new_keys = Object.keys(default_object);
            Object.keys(this.object).forEach(key => {
                if (!new_keys.includes(key)) {
                    delete this.object[key];
                }
            });
            new_keys.forEach(key => {
                if (!this.object[key] || key === 'type') {
                    Vue.set(this.object, key, default_object[key])
                }
            })
            this.$nextTick(() => {
                if (this.is_line_complete_and_active) {
                    this.$emit('changeLineComplete');
                }
            })
          },
          getInputType(key) {
            if (key !== 'value') {
                return 'text';
            } else {
                return this.value_input_type;
            }
          },
          getOptionsList(key) {
            if (this.object.type === 'filter_attr' && this.object.attributename === 'ifc_type' && key === 'value') {
                return this.$store.state.Ultra.ifc_types;
            } else if ((this.object.type === 'filter_parent' && key === 'parent_id') || this.object.type === 'filter_linked' && key === 'link_id') {
                return this.id_dropdown_options;
            } else {
                return false;
            }
          },
          getDropDownOptions(key) {
            // OPERATOR DROPDOWN
            if (key === 'operator') {
                return this.operator_dropdown_options;
            } else if (key === 'parent_type') {
                return this.dropdown_options_by_key[`parent_type_${this.tree_type}`];
            } else if (key === 'link_type') {
                return this.link_type_dropdown_options;
            } 
            else if (key === 'parent_id' || key === 'link_id') {
                return this.id_dropdown_options;
            } 
            else if (key === 'attributename') { // spatial and process attributes
                return this.dropdown_options_by_key[key][this.tree_type];
            }
            else {
                return this.dropdown_options_by_key[key];
            }
          },
          changeInput(key, evt) {
            // change value
            this.object[key] = evt; 
            // emit change when all computed and watchers are done
            this.$nextTick(() => {
                if (this.is_line_complete_and_active) {
                    this.$emit('changeLineComplete');
                }
            })
          },
      }
    }
  </script>
  <style>
    .projectstructure-filter-line {
        display: flex;
        height: 65px;
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        align-items: center;
        flex-shrink: 0;
    }
  </style>
  